import { css } from '@emotion/core';

export const textAreaCss = css({ resize: 'none' });
